import { LOCAL_STORAGE_CART } from '../constants';
import useReadStorageBookingEngine from './useReadStorageBookingEngine';

const useReadCartGroupId = () => {
  const cartData = useReadStorageBookingEngine(LOCAL_STORAGE_CART);
  return cartData != null ? cartData.highestCartGroupId : 0;
};

export default useReadCartGroupId;
